<template>
    <Modal size="lg" modal-name="question-submission-form" :title="$t('discussions.title')" class="question">
        <form @submit.prevent="submitQuestionForm">
            <input
                v-model="questionFormTitle"
                type="text"
                class="form-control form-control-sm"
                name="title"
                :placeholder="$t('discussions.questionName')"
                @change="validateQuestionFormFields()"
            />
            <span v-if="questionFormErrors.title" class="text-danger">{{ questionFormErrors.title }}</span>
            <textarea
                v-model="questionFormText"
                class="form-control form-control-sm mt-4"
                name="text"
                :placeholder="$t('discussions.questionText')"
                cols="30"
                rows="5"
                @change="validateQuestionFormFields()"
            ></textarea>
            <span v-if="questionFormErrors.text" class="text-danger">{{ questionFormErrors.text }}</span>
            <div v-if="!termsOfUseConfirmed" class="form-check mt-2">
                <input
                    id="questionFormTermsOfUse"
                    v-model="questionFormTermsOfUseChecked"
                    class="form-check-input"
                    type="checkbox"
                    @change="validateQuestionFormFields()"
                />
                <label
                    class="text-gray-light form-check-label py-1"
                    for="questionFormTermsOfUse"
                    v-html="$t('discussions.termsOfUse')"
                ></label>
            </div>
            <div v-if="questionFormErrors.termsOfUseChecked" class="text-danger">
                {{ questionFormErrors.termsOfUseChecked }}
            </div>

            <div class="mt-2 fs-12">
                <a href="#" class="text-gray-light" @click.prevent="showDiscussionRulesModal()">{{ $t('discussions.rules') }} </a>
            </div>

            <div class="text-center">
                <button class="btn btn-primary btn-rounded-circle btn-sm py-1 px-4 mt-3" type="submit" @click.prevent="submitQuestionForm">
                    {{ $t('discussions.send') }}
                </button>
            </div>
        </form>
    </Modal>
</template>

<script lang="ts">
import Modal from '~/components/Modal.vue'
import { useAuthStore } from '~/stores/auth'
import DiscussionUpsertRequest from '~/models/Api/DIscussion/DiscussionUpsertRequest'

export default {
    components: {
        Modal,
    },
    props: {
        title: {
            type: String,
            default: 'Login',
        },
        productId: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            questionFormErrors: {} as { title?: string; text?: string; termsOfUseChecked?: string },
            termsOfUseConfirmed: false,
            questionFormText: '',
            questionFormTermsOfUseChecked: false,
            questionFormTitle: '',
        }
    },
    methods: {
        async upsertPost(requestBody: DiscussionUpsertRequest, successCallback: Function) {
            useNuxtApp().$bus.$emit('hideModal')
            useNuxtApp().$bus.$emit('resetDiscussionList')
            const authStore = useAuthStore()
            const accessToken: string | null = authStore.accessToken
            const upsert = await this.$repository.discussionUpsert(requestBody, { accessToken })

            if (upsert) {
                successCallback(this)
            }
        },

        async submitQuestionForm() {
            this.questionFormSubmitted = true

            if (!this.isQuestionFormValid()) {
                return false
            }

            const requestBody = {
                productId: this.productId,
                title: this.questionFormTitle,
                text: this.questionFormText,
                termsOfUseConfirmed: this.questionFormTermsOfUseChecked,
            }

            const authStore = useAuthStore()
            const accessToken: string | null = authStore.accessToken

            this.termsOfUseConfirmed = this.questionFormTermsOfUseChecked
            useNuxtApp().$bus.$emit('resetDiscussionList')

            await this.upsertPost(
                requestBody,
                () => {
                    useNuxtApp().$bus.$emit('reloadDiscussionsList')
                    // useNuxtApp().$bus.$emit('showModal', 'thank-you-discussions')
                },
                { accessToken }
            )

            return true
        },

        validateQuestionFormFields() {
            this.questionFormErrors = {}

            if (!this.questionFormSubmitted) {
                return
            }

            if (this.questionFormTitle === '') {
                this.questionFormErrors.title = this.$t('discussions.formValidatorTitleEmpty')
            }

            if (this.questionFormText === '') {
                this.questionFormErrors.text = this.$t('discussions.formValidatorTextEmpty')
            }

            if (!this.termsOfUseConfirmed && this.questionFormTermsOfUseChecked === false) {
                this.questionFormErrors.termsOfUseChecked = this.$t('discussions.formValidatorProductDiscussionTermsOfUseEmpty')
            }
        },

        isQuestionFormValid() {
            this.validateQuestionFormFields()

            return Object.keys(this.questionFormErrors).length === 0
        },

        showDiscussionRulesModal() {
            useNuxtApp().$bus.$emit('showModal', 'discussion-rules')
        },
    },
}
</script>
